module.exports = __webpack_public_path__ + "static/media/no_session.03d47b0e.svg";